import { theme } from '@revenuemarket/design';

interface Props {
  width?: number;
  height?: number;
  color?: string;
}

export const ConversionPath = ({
  width = 16,
  height = 16,
  color = theme.colorTokens.iconDefault,
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6667 12C11.2334 12 10.8445 11.875 10.5 11.625C10.1556 11.375 9.91671 11.0556 9.78337 10.6667H6.33337C5.60004 10.6667 4.97226 10.4056 4.45004 9.88333C3.92782 9.36111 3.66671 8.73333 3.66671 8C3.66671 7.26667 3.92782 6.63889 4.45004 6.11667C4.97226 5.59444 5.60004 5.33333 6.33337 5.33333H7.66671C8.03337 5.33333 8.34726 5.20278 8.60837 4.94167C8.86948 4.68056 9.00004 4.36667 9.00004 4C9.00004 3.63333 8.86948 3.31944 8.60837 3.05833C8.34726 2.79722 8.03337 2.66667 7.66671 2.66667H4.21671C4.07226 3.05556 3.8306 3.375 3.49171 3.625C3.15282 3.875 2.76671 4 2.33337 4C1.77782 4 1.3056 3.80556 0.916707 3.41667C0.527818 3.02778 0.333374 2.55556 0.333374 2C0.333374 1.44444 0.527818 0.972222 0.916707 0.583333C1.3056 0.194444 1.77782 0 2.33337 0C2.76671 0 3.15282 0.125 3.49171 0.375C3.8306 0.625 4.07226 0.944444 4.21671 1.33333H7.66671C8.40004 1.33333 9.02782 1.59444 9.55004 2.11667C10.0723 2.63889 10.3334 3.26667 10.3334 4C10.3334 4.73333 10.0723 5.36111 9.55004 5.88333C9.02782 6.40556 8.40004 6.66667 7.66671 6.66667H6.33337C5.96671 6.66667 5.65282 6.79722 5.39171 7.05833C5.1306 7.31945 5.00004 7.63333 5.00004 8C5.00004 8.36667 5.1306 8.68056 5.39171 8.94167C5.65282 9.20278 5.96671 9.33333 6.33337 9.33333H9.78337C9.92782 8.94444 10.1695 8.625 10.5084 8.375C10.8473 8.125 11.2334 8 11.6667 8C12.2223 8 12.6945 8.19444 13.0834 8.58333C13.4723 8.97222 13.6667 9.44444 13.6667 10C13.6667 10.5556 13.4723 11.0278 13.0834 11.4167C12.6945 11.8056 12.2223 12 11.6667 12ZM2.33337 2.66667C2.52226 2.66667 2.6806 2.60278 2.80837 2.475C2.93615 2.34722 3.00004 2.18889 3.00004 2C3.00004 1.81111 2.93615 1.65278 2.80837 1.525C2.6806 1.39722 2.52226 1.33333 2.33337 1.33333C2.14448 1.33333 1.98615 1.39722 1.85837 1.525C1.7306 1.65278 1.66671 1.81111 1.66671 2C1.66671 2.18889 1.7306 2.34722 1.85837 2.475C1.98615 2.60278 2.14448 2.66667 2.33337 2.66667Z"
        fill={color}
      />
    </svg>
  );
};
